import React, { Fragment, PureComponent, Suspense, useEffect, useState, startTransition } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

// import config from '../../../../config.js';

// import PageContent from '../../components/content/PageContent.js';

import classNames from 'classnames';
import { getCmsPanelRequest, getPanelBySlugAndLanguage } from '../../CmsActions.js';
import { getPanelModelViewer } from '../../CmsPanels.js';
// import { getLoggedUser } from '../../../User/UserActions.js';

import Loader from '../../../../components/Loader/Loader.js';
import { getDefaultLanguage } from '../../../Intl/IntlHelper.js';
import { getLoggedUser } from '../../../User/UserActions.js';
import { getConfig } from '../../../Config/ConfigActions.js';

function CmsPanel({ dispatch, intl, panel, user = null, slug = '', locale = null, isTemplate = false, defaultDisplay = null, log = false, isCmsHintEnabled, ...props }) {
	const [displayEditLink, setDisplayEditLink] = useState(false);

    const setContent = (force = false) => {
		log && !isTemplate && !panel && console.log('CmsPanel::: setContent', slug, locale || intl.locale, isTemplate, panel);
		return (force || (!isTemplate && !panel)) && dispatch(getCmsPanelRequest(slug, locale || intl.locale));
    };

    // useEffect(() => {
		// log && console.log('CmsPanel::: Mounted', panel);
        // !panel && setContent();
	// }, []);

	useEffect(() => {
		log && console.log('CmsPanel::: Updated', slug, locale, intl.locale);
		log && console.log('CmsPanel::: Updated');
		setContent(true);
	}, [slug, locale, intl.locale]);

    const handleToggleEdit = () => setDisplayEditLink(true);

    const renderPanel = () => {
		const isHintActive = /* process.env.NODE_ENV === 'development' || */ (isCmsHintEnabled && user?.role === 'admin');
		log && console.log('CmsPanel::: Panel exists ?', panel, defaultDisplay);
		const editHint = isHintActive && <span className="d-block text-center text-danger"><FontAwesome name="exclamation-circle" /> CmsPanel ::: <Link to={`/console/content${panel?._id ? `/${panel._id}` : `?slug=${slug}`}`}>{slug}</Link></span>;
        if(panel && panel.blocks) {
            const ModelComponent = getPanelModelViewer(panel.model);
            return (
				<Fragment>
					<ModelComponent panel={panel} {...props} />
					{editHint}
				</Fragment>
				// <Suspense fallback={<Loader hideContent />}>
				// 	<ModelComponent panel={panel} {...props} /> {/* eslint-disable-line */}
				// </Suspense>
			);
        }
        if(defaultDisplay) {
            return (
				<div className={classNames(isHintActive && ['border-1 border border-danger'])}>
					{defaultDisplay}
					{editHint}
				</div>
			);
        }
        log && console.log('CmsPanel::: Panel not found !!', slug);
        return editHint;
    };

	log && console.log('CmsPanel::: Render', slug);
	// Remove inline onClick function: https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#7-avoid-inline-function-definition-in-the-render-function
	// className={classNames(process.env.NODE_ENV === 'development' && ['border', 'border-2', 'border-info'])}>
	return (
		<Fragment>
			{renderPanel()}
			{/* {panel?._id && (user || {}).role === 'admin' && <Button color="link" tag={Link} to={`/console/content/${panel._id}`} className="position-absolute" style={{ top: '5px', left: '5px' }}>Edit panel</Button>} */}
		</Fragment>
	);
}

function mapStateToProps(store, props) {
    return {
        panel: getPanelBySlugAndLanguage(store, props.slug, props.locale || store.intl.locale),
        user: getLoggedUser(store),
		isCmsHintEnabled: !!getConfig(store, 'cms-hint'),
    };
}

// CmsPanel.defaultProps = {
//     panel: null,
//     // user: null,
//     locale: '',
//     isTemplate: false,
//     defaultDisplay: null,
// 	log: false,
// };

CmsPanel.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    slug: PropTypes.string.isRequired,
    panel: PropTypes.object,
    user: PropTypes.object,
    locale: PropTypes.string,
    isTemplate: PropTypes.bool,
    defaultDisplay: PropTypes.any,
    log: PropTypes.bool,
    isCmsHintEnabled: PropTypes.bool,
};

// export default CmsPanel;
export default connect(mapStateToProps)(injectIntl(CmsPanel));
